import { api } from '@/shared/utils/api';
import { Site } from '@platform/shared';

export async function getSites(): Promise<Site[]> {
  return await api({
    method: 'GET',
    url: '/sites',
    priority: 'high',
  });
}
